var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-stats-1868061",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9480",
    "data-name": "Path 9480",
    d: "M30.906,13H25.844a.844.844,0,0,0-.844.844V29.031a.844.844,0,0,0,.844.844h5.063a.844.844,0,0,0,.844-.844V13.844A.844.844,0,0,0,30.906,13Zm-.844,15.188H26.687v-13.5h3.375Z",
    transform: "translate(-4.75 -2.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9481",
    "data-name": "Path 9481",
    d: "M18.906,21H13.844a.844.844,0,0,0-.844.844v8.438a.844.844,0,0,0,.844.844h5.063a.844.844,0,0,0,.844-.844V21.844A.844.844,0,0,0,18.906,21Zm-.844,8.437H14.688v-6.75h3.375Z",
    transform: "translate(-2.875 -4.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9482",
    "data-name": "Path 9482",
    d: "M6.906,17H1.844A.844.844,0,0,0,1,17.844V29.656a.844.844,0,0,0,.844.844H6.906a.844.844,0,0,0,.844-.844V17.844A.844.844,0,0,0,6.906,17ZM6.063,28.812H2.688V18.688H6.063Z",
    transform: "translate(-1 -3.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9483",
    "data-name": "Path 9483",
    d: "M13.31,14.253a.843.843,0,0,0,1.193,0L24.875,3.881V5.219a.844.844,0,1,0,1.688,0V1.844A.844.844,0,0,0,25.719,1H22.344a.844.844,0,1,0,0,1.688h1.338l-9.776,9.776L9.44,8A.844.844,0,0,0,8.247,9.19Z",
    transform: "translate(-2.094 -1)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu6);
export default __webpack_public_path__ + "static/media/menu-6.877b69578b84712095e4a6b87b2e6872.svg";
export { ForwardRef as ReactComponent };